export class CanvasScratchpad {
  private canvases: [HTMLCanvasElement | null, HTMLCanvasElement | null] = [null, null];
  private contexts: [CanvasRenderingContext2D | null, CanvasRenderingContext2D | null] = [null, null];

  dispose() {
    this.contexts = [null, null];
    this.canvases = [null, null];
  }

  private getCanvas(i: 0 | 1): { canvas: HTMLCanvasElement; ctx: CanvasRenderingContext2D } | null {
    if (!this.canvases[i]) {
      this.canvases[i] = document.createElement("canvas");
    }
    this.contexts[i] ||= this.canvases[i]!.getContext("2d");
    if (!this.contexts[i]) {
      return null;
    }
    return { canvas: this.canvases[i]!, ctx: this.contexts[i]! };
  }

  drawEmoji(emoji: string) {
    const largeDrawPad = this.getCanvas(0);
    const precideDrawPad = this.getCanvas(1);

    if (!largeDrawPad || !precideDrawPad) {
      throw new Error("canvas not available");
    }

    const { canvas, ctx } = largeDrawPad;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = "100px sans-serif";
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";
    const x = canvas.width / 2;
    const y = canvas.height / 2;
    ctx.fillText(emoji, x, y);

    const metrics = ctx.measureText(emoji);
    const width = metrics.width;
    const height = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;

    const { canvas: dstCanvas, ctx: dstCtx } = precideDrawPad;
    dstCanvas.width = width;
    dstCanvas.height = height;
    dstCtx.clearRect(0, 0, dstCanvas.width, dstCanvas.height);
    dstCtx.drawImage(
      canvas,
      x - metrics.actualBoundingBoxLeft,
      y - metrics.actualBoundingBoxAscent,
      width,
      height,
      0,
      0,
      width,
      height
    );
    return dstCanvas;
  }

  measureOnCanvas(text: string, font: string, baseline: CanvasTextBaseline = "alphabetic") {
    const canvasObj = this.getCanvas(0);
    if (!canvasObj) {
      throw new Error("canvas not available");
    }

    const { ctx } = canvasObj;
    ctx.font = font;
    ctx.textBaseline = baseline;
    return ctx.measureText(text);
  }
}
